import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "@/components/site/PageHero";
import { getCaseStudies } from "@/lib/api";
import { useSEO } from "@/lib/seo";

export default function CaseStudiesIndex() {
  const [items, setItems] = useState([]);
  useEffect(() => { getCaseStudies().then(setItems).catch(() => {}); }, []);

  useSEO({
    title: "Case Studies | RockLadder Technologies",
    description: "Field-tested outcomes across BFSI, healthcare, energy, aviation, and technology. Real metrics, redacted clients.",
    canonical: "https://rockladder.com/case-studies",
  });

  return (
    <>
      <PageHero
        eyebrow="CASE STUDIES"
        title="Real outcomes."
        gradient="Redacted clients."
        subtitle="What we've delivered across BFSI, healthcare, energy, aviation, and tech — metrics you can present to a board."
        breadcrumb={[{ label: "Case Studies" }]}
      />
      <section className="relative py-16 md:py-24">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {items.map((c) => (
            <Link
              key={c.slug}
              to={`/case-studies/${c.slug}`}
              data-testid={`case-index-${c.slug}`}
              className="group glass-panel rounded-2xl p-7 md:p-8 flex flex-col hover:border-gold transition-colors"
            >
              <div className="flex items-center gap-3 mb-5">
                <span className="font-mono text-[10px] tracking-[0.24em] text-gold-body">{c.industry.toUpperCase()}</span>
                <span className="h-px flex-1 bg-gold/15" />
                <span className="font-mono text-[10px] tracking-[0.24em] text-inkText-muted">{c.client_name}</span>
              </div>
              <h3 className="font-display text-xl md:text-2xl text-inkText-primary group-hover:text-gold transition-colors">{c.title}</h3>
              <p className="mt-4 text-sm text-inkText-muted line-clamp-3 leading-relaxed">{c.summary}</p>
              <div className="mt-6 grid grid-cols-3 gap-3">
                {(c.metrics || []).slice(0, 3).map((m) => (
                  <div key={m.label} className="text-center border border-gold/10 rounded-lg py-3">
                    <div className="font-display text-lg text-gradient-gold">{m.value}</div>
                    <div className="font-mono text-[9px] tracking-widest text-inkText-muted mt-1">{m.label.toUpperCase()}</div>
                  </div>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
